module.exports = __webpack_public_path__ + "static/img/bg-cl.f74b502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/godfather/bg-cl.jpg
// module id = juNj
// module chunks = 1